export default __webpack_public_path__ + "static/girl-bull-6af28957fa8bc7c3bfcff928051dd2fe.jpg";